import { Component, Inject,} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'information-dialogue-dialogue',
  templateUrl: './information-dialogue.component.html',
  styleUrls: ['./information-dialogue.component.scss']
})
export class InfoBoxDialog {
  constructor( @Inject(MAT_DIALOG_DATA) public data: any) {}

  onClose() {
    let dialogBox:any = document.querySelector('.cdk-overlay-backdrop');
    if(dialogBox){
      dialogBox.click()
    }
  }
}
